// extracted by mini-css-extract-plugin
export default {"page":"MissedRevenueDashboardPage_page__2o9NR","periodSection":"MissedRevenueDashboardPage_periodSection__QAcBo"};